import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';

const CONTENT_WIDTH_CLASS = {
  form: 'max-w-4xl',
  wide: 'max-w-6xl',
} as const;

type CenteredContentWidth = keyof typeof CONTENT_WIDTH_CLASS;

interface CenteredContentLayoutProps {
  header: ReactNode;
  contentWidth?: CenteredContentWidth | undefined;
  children: ReactNode;
}

export function CenteredContentLayout({
  header,
  contentWidth = 'form',
  children,
}: CenteredContentLayoutProps) {
  return (
    <div className="flex w-full flex-col gap-page-gap">
      {header}
      <div
        className={cn(
          'mx-auto flex w-full flex-col gap-page-gap',
          CONTENT_WIDTH_CLASS[contentWidth],
        )}
      >
        {children}
      </div>
    </div>
  );
}
